import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAuthModalState, AuthModalStep } from "Interfaces/interface.auth";
import { RootState } from "store/Store";

const initialState: IAuthModalState = {
  isOpen: false,
  step: "signin",
  email: undefined,
};

const authModalSlice = createSlice({
  name: "authModal",
  initialState,
  reducers: {
    openModal: (state) => {
      state.isOpen = true;
      state.step = "signin";
    },
    closeModal: (state) => {
      state.isOpen = false;
      state.email = undefined;
    },
    setStep: (state, action: PayloadAction<AuthModalStep>) => {
      state.step = action.payload;
    },
    setEmail: (state, action: PayloadAction<string>) => {
      state.email = action.payload;
    },
  },
});

export const { openModal, closeModal, setStep, setEmail } =
  authModalSlice.actions;
export default authModalSlice.reducer;

export const selectAuthModal = (state: RootState) => state.authModal;
